<app-master-header
	(onChange)="this.updateUrls($event.operatore)"
	[operatori]="true"
	cardClass="bg-gradient-light"
	headerBackground="assets/img/italy.jpg"
	title="Gestione Partner"
></app-master-header>

<ul #nav="ngbNav" class="nav-tabs mg-tabs" ngbNav (navChange)="onTabChange($event)">
	<li ngbNavItem="partner">
		<a ngbNavLink>Partner</a>
		<ng-template ngbNavContent>
			<button (click)="showFileUpload()" *show="['master']" class="btn btn-sm mb-2 btn-info">
				<i class="fa fa-upload mr-2"></i>
				Carica Partner
			</button>

			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/ribbon.png"
				title="Anagrafiche Partner"
			>
				<data-builder-table [url]="urlClassificaItalia"></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>
	<li *show="['master']" ngbNavItem="admin">
		<a ngbNavLink>Admin</a>
		<ng-template ngbNavContent>
			<button *showAdmin class="btn btn-sm mb-2 btn-info" (click)="showCreateUserModal()">
				<i class="fa fa-user mr-2"></i>
				<span>Aggiungi Utenza</span>
			</button>
			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/employee.png"
				title="Anagrafiche Admin"
			>
				<data-builder-table #adminTable [url]="urlClassificaAdmin"></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>
	<li *show="['master', 'masteragent']" ngbNavItem="district">
		<a ngbNavLink translate>Key Account</a>
		<ng-template ngbNavContent>
			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/employee.png"
				title="Anagrafiche District"
			>
				<data-builder-table [url]="urlClassificaAgenti"></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>
	<li *show="['master']" ngbNavItem="regional">
		<a ngbNavLink translate>Area Manager</a>
		<ng-template ngbNavContent>
			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/global-network.png"
				title="Anagrafiche Regional"
			>
				<data-builder-table [url]="urlClassificaAreaManager"></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>

	<li *show="['master', 'masteragent']" ngbNavItem="formazione_globale">
		<a ngbNavLink translate>Formazione - Trade MKTG Globale</a>
		<ng-template ngbNavContent>
			<button *show="['master']" class="btn btn-sm mb-2 btn-info" (click)="showCreateUserModal()">
				<i class="fa fa-user mr-2"></i>
				<span>Aggiungi Utenza</span>
			</button>
			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/global-network.png"
				title="Formazione"
			>
				<data-builder-table
					#formazioneGlobaleTable
					[url]="urlClassificaFormazione"
				></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>
	<li *show="['master', 'masteragent']" ngbNavItem="formazione_ridotto">
		<a ngbNavLink translate>Formazione - Trade MKTG Ridotto</a>
		<ng-template ngbNavContent>
			<button *show="['master']" class="btn btn-sm mb-2 btn-info" (click)="showCreateUserModal()">
				<i class="fa fa-user mr-2"></i>
				<span>Aggiungi Utenza</span>
			</button>
			<app-master-card
				bodyClass="p-0"
				image="assets/img/flats/global-network.png"
				title="Trade Marketing"
			>
				<data-builder-table
					#formazioneRidottoTable
					[url]="urlClassificaTradeMarketing"
				></data-builder-table>
			</app-master-card>
		</ng-template>
	</li>
</ul>

<div [ngbNavOutlet]="nav"></div>

<ng-template #fileUploadModal let-modal size="xl">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Caricamento Partner</h4>
		<button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body p-0">
		<app-spinner status="loading" *ngIf="importPartners"></app-spinner>
		<div class="form-group p-4" *ngIf="importLogs.length === 0 && !importPartners">
			<label for="file">File</label>
			<div class="custom-file" id="file">
				<input
					(change)="uploadFile($event)"
					aria-describedby="fileHelp"
					class="custom-file-input"
					id="exampleInputFile"
					type="file"
				/>
				<label class="custom-file-label" for="exampleInputFile">Seleziona il file</label>
			</div>
		</div>
		<div *ngIf="importLogs.length > 0" class="table-responsive" style="max-height: 600px">
			<table class="table table-sm">
				<tr>
					<th>Tipo</th>
					<th>Log</th>
				</tr>
				<tr *ngFor="let log of importLogs">
					<td class="text-center">
						<i
							class="fa"
							[ngClass]="{
								'fa-info-circle text-info': log.type === 'info',
								'fa-check-circle text-success': log.type === 'success',
								'fa-times-circle text-danger': log.type === 'error'
							}"
						></i>
					</td>
					<td>{{ log.message }}</td>
				</tr>
			</table>
		</div>
	</div>
</ng-template>

<ng-template #createUserModal let-modal size="sm">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Creazione Anagrafica per {{ userTabLabel }}</h4>
		<button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<ngx-spinner
			[fullScreen]="false"
			bdColor="rgba(0, 0, 0, 0.8)"
			color="#fff"
			name="creatingUser"
			size="default"
			type="square-jelly-box"
		>
			<p style="color: white">Caricamento...</p>
		</ngx-spinner>
		<form [formGroup]="userForm">
			<div class="form-group">
				<label for="ragsociale">Ragione Sociale</label>
				<input
					formControlName="ragsociale"
					class="form-control"
					id="ragsociale"
					type="text"
					placeholder="Ragione Sociale"
					[ngClass]="{
						'is-invalid': userForm.get('ragsociale').invalid && userForm.get('ragsociale').touched
					}"
				/>
				<div
					class="invalid-feedback"
					*ngIf="userForm.get('ragsociale').invalid && userForm.get('ragsociale').touched"
				>
					Inserire la Ragione Sociale
				</div>
				<div class="invalid-feedback" *ngIf="userForm.get('ragsociale').errors?.minlength">
					La ragione sociale deve contenere almeno
					{{ userForm.get('ragsociale').errors?.minlength.requiredLength }} caratteri
				</div>
			</div>
			<div class="form-group">
				<label for="username">Username</label>
				<input
					formControlName="username"
					type="text"
					class="form-control"
					id="username"
					placeholder="Username"
					[ngClass]="{
						'is-invalid': userForm.get('username').invalid && userForm.get('username').touched
					}"
				/>
				<div
					class="invalid-feedback"
					*ngIf="userForm.get('username').invalid && userForm.get('username').touched"
				>
					Inserire l'username
				</div>
				<div class="invalid-feedback" *ngIf="userForm.get('username').errors?.minlength">
					L'username deve contenere almeno
					{{ userForm.get('username').errors?.minlength.requiredLength }} caratteri
				</div>
			</div>
			<div class="form-group">
				<label for="email">Email</label>
				<input
					formControlName="email"
					type="text"
					class="form-control"
					id="email"
					placeholder="Email"
					[ngClass]="{
						'is-invalid':
							(userForm.get('email').invalid && userForm.get('email').touched) ||
							userForm.get('email').errors?.email
					}"
				/>
				<div
					class="invalid-feedback"
					*ngIf="userForm.get('email').invalid && userForm.get('email').touched"
				>
					Inserire un'email
				</div>
				<div class="invalid-feedback" *ngIf="userForm.get('email').errors?.email">
					Formato email non valido
				</div>
			</div>
			<div class="form-group">
				<label for="cellulare">Cellulare</label>
				<input
					formControlName="cellulare"
					type="text"
					class="form-control"
					id="cellulare"
					placeholder="Cellulare"
					[ngClass]="{
						'is-invalid':
							(userForm.get('cellulare').invalid && userForm.get('cellulare').touched) ||
							userForm.get('cellulare').errors?.pattern
					}"
				/>
				<div
					class="invalid-feedback"
					*ngIf="userForm.get('cellulare').invalid && userForm.get('cellulare').touched"
				>
					Inserire un cellulare
				</div>
				<div class="invalid-feedback" *ngIf="userForm.get('cellulare').errors?.pattern">
					Il formato del cellulare non è valido
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer d-flex align-items-center justify-content-end">
		<button class="btn btn-danger mr-2" (click)="closeUserModal()">Annulla</button>
		<button class="btn btn-success" (click)="createUser()" [disabled]="userForm.invalid">
			<i class="fa fa-save"></i>
			<span>Salva</span>
		</button>
	</div>
</ng-template>
